export enum CookieItemKeyEnum {
  token = 'token',
  officeFile = 'officeFile',
}
